import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const RedoIcon = ({ color, size = 24, sx, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.0015 14.0806C4.38972 9.5295 9.20452 6.96545 13.7556 8.35367C16.382 9.15478 18.3466 11.097 19.2718 13.4711M20.9985 9.91958L19.7417 14.0399L15.6214 12.7831"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
